export default __webpack_public_path__ + "static/media/banner4.ad17219e.png";